import React from 'react';
import PublicLayout from '../components/PublicLayout';
import HomeGrid from '../components/HomeGrid';
const h=React.createElement;
export default function Home(props) {
  return h(PublicLayout,{page:'home',isLoggedIn:props.isLoggedIn},
    h(HomeGrid,{isLoggedIn:props.isLoggedIn}));
}

